class MenuStoryCards {
  constructor(container) {
    this.track = container.querySelector('.story-cards__track');
    this.cards = this.track.children;
    this.prevButton = container.querySelector('.story-cards__button--prev');
    this.nextButton = container.querySelector('.story-cards__button--next');
    
    if (this.cards.length <= 3) return;
    
    this.currentIndex = 0;
    this.cardWidth = 100 / 3;
    this.maxIndex = this.cards.length - 3;
    
    this.initializeSlider();
    this.addEventListeners();
    this.updateButtonsVisibility();
  }
  
  initializeSlider() {
    this.track.style.gridTemplateColumns = `repeat(${this.cards.length}, ${this.cardWidth}%)`;
  }
  
  addEventListeners() {
    this.prevButton?.addEventListener('click', () => this.slide('prev'));
    this.nextButton?.addEventListener('click', () => this.slide('next'));
  }
  
  slide(direction) {
    if (direction === 'prev' && this.currentIndex > 0) {
      this.currentIndex--;
    } else if (direction === 'next' && this.currentIndex < this.maxIndex) {
      this.currentIndex++;
    }
    
    const translateX = -this.currentIndex * this.cardWidth;
    this.track.style.transform = `translateX(${translateX}%)`;
    this.updateButtonsVisibility();
  }
  
  updateButtonsVisibility() {
    if (this.prevButton) {
      this.prevButton.classList.toggle('story-cards__button--hidden', this.currentIndex === 0);
    }
    if (this.nextButton) {
      this.nextButton.classList.toggle('story-cards__button--hidden', this.currentIndex === this.maxIndex);
    }
  }
}
